import { BaggageType, GdsServiceVipSubType, OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { ServiceSummaryType } from '../model/types';

export function getRelatedServiceType(
	type: OrderAdditionalServiceGdsServiceServiceType,
	subType?: BaggageType | GdsServiceVipSubType,
	options: { isAnimalAvailable?: boolean } = {}
): ServiceSummaryType {
	const { isAnimalAvailable } = options;

	switch (type) {
		case OrderAdditionalServiceGdsServiceServiceType.Seat:
			return 'Seat';
		case OrderAdditionalServiceGdsServiceServiceType.Baggage:
			if (isAnimalAvailable) {
				switch (subType) {
					case BaggageType.PetInHandCarrier:
						return 'Animal';
					default:
						return 'Baggage';
				}
			} else {
				return 'Baggage';
			}
		case OrderAdditionalServiceGdsServiceServiceType.Meal:
			return 'Meal';
		case OrderAdditionalServiceGdsServiceServiceType.BusinessLounge:
			return 'BusinessLounge';
		case OrderAdditionalServiceGdsServiceServiceType.Vip:
			switch (subType) {
				case GdsServiceVipSubType.BaggageDelivery:
					return 'BaggageDelivery';
				case GdsServiceVipSubType.BusinessLounge:
				case GdsServiceVipSubType.BusinessLoungeInternational:
					return 'BusinessLounge';
				case GdsServiceVipSubType.PriorityBoarding:
					return 'PriorityBoarding';
				case GdsServiceVipSubType.CapsuleHotel:
					return 'CapsuleHotel';
				case GdsServiceVipSubType.GroundTransportation:
					return 'Transfer';
				case GdsServiceVipSubType.RefundableTicket:
					return 'RefundableTicket';
				case GdsServiceVipSubType.Upgrade:
					return 'Upgrade';
				case GdsServiceVipSubType.SMS:
					return 'Sms';
				case GdsServiceVipSubType.UnknownSubtype:
					return null;
				default:
					return null;
			}
		case OrderAdditionalServiceGdsServiceServiceType.Misc:
			return 'Misc';
		default:
			return null;
	}
}
